import { API_BASE_URL } from './apiService';

export const createCheckoutSession = async (plan, billingPeriod, userEmail, userId, companyId, trial = false) => {
  const response = await fetch(`${API_BASE_URL}/create-checkout-session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ plan, billing_period: billingPeriod, user_email: userEmail, user_id: userId, company_id: companyId, trial }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Network error' }));
    throw new Error(error.detail || 'Failed to create checkout session');
  }

  return response.json();
};

export const getSubscription = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/subscription/${userId}`);
    if (!response.ok) return null;
    const data = await response.json();
    return data.subscription;
  } catch (err) {
    console.error('Error fetching subscription:', err);
    return null;
  }
};

export const createPortalSession = async (userId) => {
  const response = await fetch(`${API_BASE_URL}/create-portal-session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Network error' }));
    throw new Error(error.detail || 'Failed to create portal session');
  }

  return response.json();
};